import { cn } from "@/lib/utils";
import type { ImgHTMLAttributes } from "react";

interface FocalImageProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, "style"> {
  focalPointX?: number;
  focalPointY?: number;
  zoom?: number;
}

export function FocalImage({
  focalPointX = 0.5,
  focalPointY = 0.5,
  zoom = 1,
  className,
  ...props
}: FocalImageProps) {
  const objectPosition = `${focalPointX * 100}% ${focalPointY * 100}%`;

  if (zoom <= 1) {
    return (
      <img
        className={cn("object-cover", className)}
        style={{ objectPosition }}
        {...props}
      />
    );
  }

  return (
    <img
      className={cn("object-cover", className)}
      style={{
        objectPosition,
        transform: `scale(${zoom})`,
        transformOrigin: `${focalPointX * 100}% ${focalPointY * 100}%`,
      }}
      {...props}
    />
  );
}
